import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getApplications = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("applications", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postApplication = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("applications", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putApplication = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ APPLICATION_ID: id });
    const response = await serverApi.put("applications", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPendingStatus = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("applications/checkPending", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
